const dispatchCustomEvent = function (identifier, detail = {}) {
  document.body.dispatchEvent(
    new CustomEvent(identifier, {
      bubbles: true,
      detail: detail,
    })
  );
};

const subscribeCustomEvent = function (identifier, callback) {
  document.body.addEventListener(identifier, callback);
};

const unsubscribeCustomEvent = function (identifier, callback) {
  document.body.removeEventListener(identifier, callback);
};

export { dispatchCustomEvent, subscribeCustomEvent, unsubscribeCustomEvent };
